import { ref } from 'vue';
import { Bus } from '@orion.ui/orion';
import BaseSetupService from '@/setup/BaseSetupService';
import { reactive } from 'vue';

type Props = SetupProps<typeof BaseListItemSetupService.props>

export enum DetailPrefixForRouter {
	AdvancedPaymentDemand = 'AdvancedPaymentDemand',
  Bill = 'Bill',
	ClientContract = 'ClientContract',
	TempWorkerContract = 'TempWorkerContract',
	Register = 'Register',
	HandicappedWorkerList = 'HandicappedWorkerList',
	ClientProvisionDocument = 'ClientProvisionDocument',
	TempWorkerProvisionDocument = 'TempWorkerProvisionDocument',
	SalarySlip = 'SalarySlip',
	Certificate = 'Certificate',
	WithholdingTaxAttestation = 'WithholdingTaxAttestation',
	TripAttestation = 'TripAttestation',
	PoleEmploiAttestation = 'PoleEmploiAttestation',
	Order = 'Order',
	TempWorker = 'TempWorker',
	JobOffer = 'JobOffer',
	OrganizationUser = 'OrganizationUser',
	MissionPlace = 'MissionPlace',
	OrganizationCompany = 'OrganizationCompany',
	TimeTicket = 'TimeTicket',
	TimeTicketWeek = 'TimeTicketWeek',
	DigitalSafe = 'DigitalSafe',
	UserClient = 'User',
	OrderDetailsClientContract = 'OrderDetailsClientContract',
	OrderDetailsTempWorkerContract = 'OrderDetailsTempWorkerContract',
	ContractProlongation = 'ContractProlongation',
}
export default abstract class BaseListItemSetupService<P> extends BaseSetupService<Props & P> {
	protected abstract detailPrefixForRouter: DetailPrefixForRouter | undefined;
	protected abstract get itemId(): number | undefined;

	static readonly props = { selected: Boolean };

	_el = ref<Element>();

	private readonly state = reactive({ tagSelectOpen: false });

	protected get routeParamKey () { return 'id'; }

	get detailsRouteName () { return `${this.detailPrefixForRouter}Details`; }
	get isOpened () {
		return this.route.name === this.detailsRouteName && +this.route.params[this.routeParamKey] === this.itemId;
	}

	get tagSelectOpen () { return this.state.tagSelectOpen; }
	set tagSelectOpen (val) { this.state.tagSelectOpen = val; }


	protected onMounted () {
		super.onMounted();
		Bus.on('paged-list-order-header-over', (key) => {
			this._el.value?.querySelector(`[data-order="${key}"]`)?.classList.add('arm-order-highlight');
		});
		Bus.on('paged-list-order-header-out', (key) => {
			this._el.value?.querySelector(`[data-order="${key}"]`)?.classList.remove('arm-order-highlight');
		});

		Bus.on(`discussion:handle-document-click-${this.itemId}`, () => {
			this.handleDocumentClick();
		});
	}


	handleDocumentClick () {
		if (this.itemId && this.detailPrefixForRouter) {
			this.router.push(
				this.isOpened
					? {
						name: this.detailPrefixForRouter,
						query: this.route.query,
					}
					: {
						name: this.detailsRouteName,
						params: { id: this.itemId },
						query: this.route.query,
					});
		}
	};
}
